"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DESC = exports.ASC = void 0;
var ASC = 'ASC';
exports.ASC = ASC;
var DESC = 'DESC';
exports.DESC = DESC;


//////////////////
// WEBPACK FOOTER
// ./js/constants/search/SortOrder.js
// module id = 323
// module chunks = 209 210 211 212 213